// Conventional formats
export const MM_DD_YYYY = 'MM-DD-YYYY'; // Example: "12-25-2024"
export const DD_MM_YYYY = 'DD-MM-YYYY'; // Example: "25-12-2024"
export const MM_DD_YY = 'MM-DD-YY'; // Example: "12-25-24"
export const DD_MM_YY = 'DD-MM-YY'; // Example: "25-12-24"
export const YYYY_MM_DD = 'YYYY-MM-DD'; // Example: "2024-12-24"

// Conventional formats with slash
export const MM_SLASH_DD_SLASH_YYYY = 'MM/DD/YYYY'; // Example: "12/25/2024"
export const DD_SLASH_MM_SLASH_YYYY = 'DD/MM/YYYY'; // Example: "25/12/2024"
export const DD_SLASH_MM_SLASH_YY = 'DD/MM/YY'; // Example: "25/12/24"
export const MM_SLASH_DD_SLASH_YY = 'MM/DD/YY'; // Example: "12/25/24"
export const MM_DOT_DD_DOT_YYYY = 'MM.DD.YYYY'; // Example: "12.25.2025"

export const TIME_FORMAT_1 = 'h:mm:ss';

// Descriptive formats
export const DESC_FORMAT_1 = 'MMMM Do YYYY, h:mm:ss a'; // Example: "December 25th 2024, 5:30:45 pm"
export const DESC_FORMAT_2 = 'MMMM Do YYYY, h:mm:ssa'; // Example: "December 25th 2024, 5:30:45pm"
export const DESC_FORMAT_3 = 'MMMM DD YYYY, h:mm:ss a'; // Example: "December 25 2024, 5:30:45 pm"
export const DESC_FORMAT_4 = 'MMMM DD YYYY, h:mm:ssa'; // Example: "December 25 2024, 5:30:45pm"
export const DESC_FORMAT_5 = 'MMM Do YYYY, h:mm:ss a'; // Example: "Dec 25th 2024, 5:30:45 pm"
export const DESC_FORMAT_6 = 'MMM Do YYYY, h:mm:ssa'; // Example: "Dec 25th 2024, 5:30:45pm"
export const DESC_FORMAT_7 = 'MMM DD YYYY, h:mm:ss a'; // Example: "Dec 25 2024, 5:30:45 pm"
export const DESC_FORMAT_8 = 'MMM DD YYYY, h:mm:ssa'; // Example: "Dec 25 2024, 5:30:45pm"
export const DESC_FORMAT_9 = 'YYYY-MM-DD HH:mm:ss'; // Example: "2024-12-17 19:52:39"
export const DESC_FORMAT_10 = 'MMM DD, YYYY hh:mma'; // Example: "Dec 17, 2024 02:30pm"
export const DESC_FORMAT_11 = 'DD/MMM/YY h:mm a'; // Example: "12/Dec/24 5:30 pm"
export const DESC_FORMAT_12 = 'MMMM Do, YYYY'; // Example: "December 17th, 2024"
export const DESC_FORMAT_13 = 'MMMM D, YYYY, h:mm A'; // Example: "January 3, 2025, 10:08 PM"

// Short formats
export const DD = 'DD'; // Example: "25"
export const MM = 'MM'; // Example: "12"
export const YYYY = 'YYYY'; // Example: "2024"

// Extra special formats
export const ABSOLUTE_FIRST_DATE = '01-01-0000'; // Example: 01-01-0000
